import {Box, Button, Chip, CircularProgress, Container, Paper, Stack, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {api} from "../../services/apiService";
import {DataGrid} from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import {useNavigate} from "react-router-dom";

export default function Users() {
    const navigate = useNavigate();

    const [users, setUsers] = useState([])
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(50)
    const [query, setQuery] = useState("")
    const [roles, setRoles] = useState([])
    const [roleSelected, setRoleSelected] = useState(null)
    const [loading, setLoading] = useState(true)
    const [datagridLoading, setDatagridLoading] = useState(true)

    useEffect(() => {
        api.get(`admin/users?page=${page}&perPage=${perPage}${roleSelected ? `&role=${roleSelected}` : ''}${query ? `&query=${query}` : ''}`)
            .then(response => {
                setUsers(response.data.users)
                setTotal(response.data.total)
                setDatagridLoading(false)
            })
    }, [total, page, perPage, query, roleSelected])

    useEffect(() => {
        api.get('admin/user_roles')
            .then(response => {
                setRoles(response.data.roles)
                setLoading(false)
            })
    }, [])


    const columns = [
        {field: "lastName", headerName: "Nom", flex: 1, minWidth: 150},
        {field: "firstName", headerName: "Prénom", flex: 1, minWidth: 150},
        {field: "email", headerName: "Email", flex: 1.5, minWidth: 200},
        {field: "role", headerName: "Rôle", flex: 1, minWidth: 120},
    ];


    return (
        !loading ? (
                <Container>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2
                    }}>
                        <Box>
                            <Typography variant="h1">Utilisateurs</Typography>
                            {/* Barre de recherche */}
                            <TextField
                                label="Rechercher un utilisateur"
                                variant="outlined"
                                fullWidth
                                value={query}
                                onChange={(e) => {
                                    setQuery(e.target.value)
                                    setDatagridLoading(true)
                                }}
                            />
                            {/*  Boutons pour sélectionner le role si on veut filter par role  */}
                            <Stack direction="row" spacing={1} sx={{mt: "1rem", overflowX: "auto"}}>
                                {roles.map((role, index) => (
                                    <Chip
                                        key={index}
                                        label={role.label}
                                        color={roleSelected === role.value ? "primary" : "default"}
                                        onClick={() => {
                                            setRoleSelected(roleSelected === role.value ? null : role.value)
                                            setDatagridLoading(true)
                                        }}
                                    />
                                ))}
                            </Stack>
                        </Box>


                        <Button variant="contained" color="primary" onClick={() => navigate('create')}>
                            Ajouter un utilisateur
                        </Button>
                    </Box>


                    {/* Datagrid */}
                    <Paper sx={{mt: 4}}>
                        <DataGrid
                            columns={columns}
                            rows={users}
                            rowCount={total}
                            paginationModel={{page: page, pageSize: perPage}}
                            pageSizeOptions={[10, 25, 50]}
                            paginationMode="server"
                            onPaginationModelChange={model => {
                                setPage(model.page);
                                setPerPage(model.pageSize);
                                setDatagridLoading(true);
                            }}
                            loading={datagridLoading}
                            sx={{
                                border: 0,
                                cursor: "pointer",
                                "& .MuiDataGrid-row:hover": {
                                    backgroundColor: "#f0f0f0",
                                },
                                backgroundColor: "#fff",
                            }}

                        />
                    </Paper>
                </Container>
            )
            :
            <Container maxWidth="lg" sx={{
                mt: 4,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh"
            }}>
                <Stack spacing={2} alignItems="center">
                    <Box>
                        <Typography variant="h6" sx={{mb: 2}}>Chargement...</Typography>
                        <Box sx={{display: "flex", justifyContent: "center"}}>
                            <CircularProgress color="primary"/>
                        </Box>
                    </Box>
                </Stack>
            </Container>
    )
}